<template>
    <Page subtype="conditions" class="m-5 sm:m-7" :show-header="false" />
</template>

<script setup>
import { ROUTES } from "@utils/routes";
import Page from "@components/content/page";

defineI18nRoute({
  paths: {
    cs: '/podminky',
    en: '/terms',
    sk: '/podmienky',
    pl: '/warunki',
    de: '/bedingungen'
  }
});

const config = useRuntimeConfig();
const canonical = config.public.appBaseUrl + translatePath(ROUTES.CODE.TERMS);

useHead({ link: [ { rel: 'canonical', href: canonical } ] });

</script>
